import Message from './message';
export default class IdentifyMessage extends Message {
    fire(traits, options) {
        this.call({
            traits,
            apiMethod: 'identify',
        }, options);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWRlbnRpZnktbWVzc2FnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jZHAvbWVzc2FnZXMvaWRlbnRpZnktbWVzc2FnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLE9BQU8sTUFBTSxXQUFXLENBQUM7QUFJaEMsTUFBTSxDQUFDLE9BQU8sT0FBTyxlQUFnQixTQUFRLE9BQTZCO0lBQ3hFLElBQUksQ0FBQyxNQUFjLEVBQUUsT0FBdUM7UUFDMUQsSUFBSSxDQUFDLElBQUksQ0FDUDtZQUNFLE1BQU07WUFDTixTQUFTLEVBQUUsVUFBVTtTQUN0QixFQUNELE9BQU8sQ0FDUixDQUFDO0lBQ0osQ0FBQztDQUNGIn0=